<app-modal-pesquisa-lista
  [aberta]="aberta"
  titulo="Pesquisar funcionario"
  [termo]="termo"
  nomeCampo="buscaFuncionarioModal"
  placeholder="Digite nome, matricula ou CPF"
  mensagemVazia="Nenhum funcionario encontrado."
  [itens]="funcionarios"
  [rotuloItem]="rotuloItem"
  [detalheItem]="detalheComCpf"
  (termoChange)="termoChange.emit($event)"
  (selecionar)="selecionarFuncionario($event)"
  (limpar)="limpar.emit()"
  (fechar)="fechar.emit()">
</app-modal-pesquisa-lista>
